import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { handleFormatToNumeric } from "src/shared/Utils/FormatMoney";

interface IUseFormEditarParcela {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: (values: any) => void;
  values: any;
}

export const UseFormEditarParcela = ({
  setOpenModal,
  onSave,
  values,
}: IUseFormEditarParcela) => {
  const { handleGetAlert } = useLayoutMainContext();
  const [loading, setLoading] = useState(false);

  const handleEditarParcela = async () => {
    if (!values.parcela && values.parcela !== 0) {
      return handleGetAlert({ message: "Parcela é obrigatória" });
    }

    if (!values.vencimento) {
      return handleGetAlert({ message: "Vencimento é obrigatório" });
    }

    if (!values.vidas || values.vidas <= 0) {
      return handleGetAlert({ message: "Vidas deve ser maior que zero" });
    }

    if (!values.valorBoleta || Number(handleFormatToNumeric(String(values.valorBoleta))) <= 0) {
      return handleGetAlert({ message: "Valor da mensalidade deve ser maior que zero" });
    }

    setLoading(true);

    try {
      // Preparar valores para salvar
      const valoresFormatados = {
        ...values,
        valorBoleta: Number(handleFormatToNumeric(String(values.valorBoleta))),
      };

      // Chamar callback para atualizar na tabela
      onSave(valoresFormatados);

      handleGetAlert({ message: "Parcela editada com sucesso!" });
      setOpenModal(false);
    } catch (error: any) {
      handleGetAlert({ message: error?.message || "Erro ao editar parcela" });
    } finally {
      setLoading(false);
    }
  };

  return {
    handleEditarParcela,
    loading,
  };
};

